import React, { Fragment, useState, useRef } from "react";
import {
  faTimes,
  faAsterisk,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./InviteStudent.css";
import "../AdminPages.css";
import GetAdminService from "../../../services/admin/GetAdminService";
import CustomLoader from "../../customLoader/CustomLoader";
import swal from "sweetalert";

const InviteStudent = ({ setOpenInviteStudent, schoolId }) => {
  const [emailError, setEmailError] = useState(true);
  const [email, setEmail] = useState();
  const counselorNameRef = useRef();
  const timeoutRef = useRef();
  const [showCounselorNameContainer, setShowCounselorNameContainer] = useState(
    false
  );
  const [counselorNameList, setCounselorNameList] = useState();
  const [counselorName, setCounselorName] = useState();
  const [counselorNameLoading, setCounselorNameLoading] = useState(false);
  const [counselorId, setCounselorId] = useState();

  const getCounselorsList = (value, role, school) => {
    setCounselorNameLoading(true);
    GetAdminService.getCounselorsList(value, role, school)
      .then((data) => {
        setCounselorNameList(data?.data?.result);
        setCounselorNameLoading(false);
        setShowCounselorNameContainer(true);
      })
      .catch(() => {
        setCounselorNameLoading(false);
      });
  };

  const sendEmail = () => {
    let obj = {
      email: email,
      school: schoolId,
      role: "student",
    };
    if (obj.role == "student") {
      obj.counselor = counselorId;
    }
    GetAdminService.sendCounselorEmail(obj)
      .then(() => {
        swal({
          title: "Successfully",
          text: "Email send successfully",
          icon: "success",
          dangerMode: true,
          buttons: {
            ok: true,
          },
          closeOnClickOutside: true,
        });
      })
      .catch((error) => {
        swal({
          title: "Oops!!",
          text: error?.response?.data?.message,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true,
          },
          closeOnClickOutside: true,
        });
      });
    setEmailError(true);
    setEmail("");
    setCounselorName("");
  };

  const handleCounselorName = () => {
    clearTimeout(timeoutRef.current);
    setCounselorName(counselorNameRef.current.value);
    if (!counselorNameRef.current.value) {
      setShowCounselorNameContainer(false);
      setCounselorNameList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getCounselorsList(
          counselorNameRef.current.value,
          "counselor",
          schoolId
        );
      }, 1000);
    }
  };

  const handleSelectedCounselorName = (item) => {
    setCounselorNameList([item]);
    setShowCounselorNameContainer(false);
    setCounselorName(item?.name);
    setCounselorId(item?.id);
  };

  const handleEmail = (e) => {
    setEmail(e.target.value.toLowerCase());
    if (e.target.value.match("[a-z0-9]+@[a-z]+\\.[a-z]{2,3}"))
      setEmailError(false);
    else {
      setEmailError(true);
    }
  };

  return (
    <Fragment>
      <div className="goal-full-container">
        <div className="drawer-header">
          <h3 className="drawer-title">Invite Student</h3>
          <button
            type="button"
            className="drawer-close-btn"
            onClick={() => setOpenInviteStudent(false)}
            aria-label="Close"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        <div className="drawer-section">
          <div className="drawer-form-row">
            <div className="form-label-col">
              Counselor
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col" style={{ position: "relative" }}>
              <input
                ref={counselorNameRef}
                type="text"
                placeholder="Type the counselor name"
                value={counselorName}
                onChange={handleCounselorName}
                autoComplete="off"
              />
              {showCounselorNameContainer && (
                <ul className="drawer-autocomplete">
                  {counselorNameLoading && <CustomLoader />}
                  {counselorNameList?.length > 0 &&
                    counselorNameList.map((item, index) => (
                      <li
                        onClick={() => handleSelectedCounselorName(item)}
                        key={index}
                      >
                        {item.name}
                      </li>
                    ))}
                </ul>
              )}
            </div>
          </div>
        </div>

        <div className="drawer-section">
          <p className="drawer-section-label">Contact</p>
          <div className="drawer-form-row">
            <div className="form-label-col">
              Email
              <span className="required-marker">*</span>
            </div>
            <div className="form-field-col">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={handleEmail}
              />
            </div>
          </div>
        </div>

        <div className="drawer-footer">
          <button
            type="button"
            className="drawer-btn-save"
            onClick={sendEmail}
            disabled={!counselorName || emailError}
          >
            <FontAwesomeIcon icon={faPaperPlane} />
            Invite
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default InviteStudent;
